<template lang="pug">
div
    .row.sub-navigation
        .columns.large-24
            nav.breadcrumbs.left
                router-link(:to="`${get_locale()}/family/dashboard`") {{t('app.navigation.dashboard')}}
                span {{t('app.navigation.find_programs')}}
    search_field

    nav.pagination(v-if="totalResults>PER_PAGE")
        pagination(current="currentPage" :total="totalResults" :per-page="PER_PAGE"  page-changed="nextPage")
    .row(v-if="orgs.length>0")
      .column.large-24
        .content-block.collapse
            header
                .title {{t('app.programs.search.search_results')}}
            section.content
                .row
                    .columns.large-24.organization-list
                        search_result(v-for="org in orgs" :org="org" :key="`${org._index}_${org.id}`")
    .row(v-else)
      .column.large-24
        .content-block.collapse
            section.content
                #no-results-found
                    .content
                        .item-label(v-if="loading")
                            | Loading....
                        .item-label(v-else)
                            | {{t('app.programs.search.no_results')}}
    nav.pagination(v-if="totalResults>PER_PAGE")
        pagination(:total="totalResults" :per-page="PER_PAGE")
</template>
<script>
import search_field from 'templates/shared/blocks/organization/search_field.vue'
import search_result from './_search_result'
import pagination from '../shared/_pagination2'
const PER_PAGE = 25
export default {
  components: {search_field,search_result,pagination},
  data(){
    return {
      orgs: [],
      loading: true,
      PER_PAGE,
      totalResults: 0
    }
  },
  watch: {
    '$route': {
      handler: 'makeSearch',
      immediate: true,
    }
  },
  methods:{
    async makeSearch(){
      this.loading = true
      let params={search_filter: {states: this.$route.query.query_state}, query: this.$route.query.query}
      if ((params.search_filter.states||"").length===0) delete params.search_filter.states;
      if ((params.query||"").length===0){
        params.query = "*"
        if (!params.search_filter.states) params.order = "name"
      }
      params.per  = PER_PAGE
      params.page = this.$route.query.page

      const resp = await this.axios.get('/api2/family/search', {params: params})
      this.totalResults = parseInt(resp.headers['x-total'])
      this.orgs = resp.data.object
      this.loading = false
    },
  }
}
</script>
